import { IParamsCourseObject } from '@/courses/interfaces/params-course-object.interface';
import { IParamsCreateFileObject } from '@/courses/interfaces/params-create-file-object.interface';
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import EdCreateFileObject from '../ed-create-file-object/ed-create-file-object.vue';
import KEYS from '@/values/keys';
import { IResultCreateFileObject } from '@/courses/interfaces/result-create-file-object.interface';
import { SECTION_TYPES } from '@/content/values/sections';
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';
import EdPdfRotatePages from '@/courses/components/ed-pdf-rotate-pages/ed-pdf-rotate-pages.vue'

@Component({
  components: {
    EdCreateFileObject,
    EdPdfRotatePages
  }
})
export default class EdCourseCreateFileObject extends Mixins(CreateObjectsMixin) {

  // @Prop() readonly params: IParamsCourseObject;    //Typescript upgrade
  declare readonly params: IParamsCourseObject;   
  public rotatePages: boolean = false;
  public rotatePagesParams: any = {};
  public rotateDegreesInfo: any = [];
  public isReadyToShow: boolean = true;


  public createParams: IParamsCreateFileObject = {
    edition: false,
    homework: { show: true },
    grade: { show: false },
    labelSections: '',
  }; 
  public loaded: boolean = false;
  public fileComponent: any = null;

  get courseId() {
    return this.params.courseId;
  }

  get classId() {
    return this.params.classId;
  }

  get parentId() {
    return this.params.parentId;
  }

  get section() {
    return this.params.section;
  }

  get submissionDates() {
    return this.section?.submissionDates;
  }
  get pdfUrl() {
    return this.params.section.assetsInfo[0].pdfUrl ? this.params.section.assetsInfo[0].pdfUrl : this.course.viewer.sectionSelected.assetsInfo[0].pdfUrl;
  }

  onSave(fileObject: IResultCreateFileObject) {
    this.fileComponent = this.$refs.EdCreateFileObject;
    this.fileComponent.setSaving(true);
    if(this.params.edition) {
      this.updateFile(fileObject);
      return;
    }
    this.saveFile(fileObject);
  }

  async updateFile(fileObject: IResultCreateFileObject) {
    try {
      let req: any = { 
        name: fileObject.name,
        type: fileObject.type,
        sectionId: this.section.sectionId,
        homework: fileObject.homework,
        homeworkPoints: fileObject.homeworkPoints,
        homeworkWeight: fileObject.homeworkWeight,
        teacherOnly: this.section.teacherOnly,
        text: '',
        courseId: this.courseId,
        dueDate: this.getSchoolDayIndex(fileObject.dueDate),
        lastSchoolDay: this.getSchoolDayIndex(fileObject.lastDate),
        labelSections: fileObject.labelSections,
        submissionDates: {
          dueSchoolDay: this.getSchoolDayIndex(fileObject.dueDate),
          dueDate: fileObject.dueDate,
          lastSchoolDay: this.getSchoolDayIndex(fileObject.lastDate),
          lastDate: fileObject.lastDate,
          dueDateAuto: fileObject.dueDateAuto,
          lastDateAuto: fileObject.lastDateAuto
        },
        archiveCurrentHomeworks: false,
        saveAsPdf: fileObject.saveAsPdf,
        rotatePdfInfo: this.rotateDegreesInfo,
        component: fileObject.component,
      };
      if(fileObject.fileAdded) {
        /* The previous file is removed */
        if(this.section && this.section.text) {
          await this.$Courses.Store.removeFileA(this.section);
        }
        /* The new file is added */
        await this.$Courses.Store.updateFileA({
          file: fileObject.file,
          sectionId: this.section.sectionId,
          courseId: this.courseId,
          sectionType: (fileObject.type === SECTION_TYPES.LESSON_PPT_HTML.code) ? SECTION_TYPES.LESSON_PPT_HTML.code :
          (fileObject.type === SECTION_TYPES.LESSON_PDF_IMAGE.code) ? fileObject.type : SECTION_TYPES.LESSON_TEMP_FILE.code
        });
        req.archiveCurrentHomeworks = true;
      }
      /* The data is updated */
      let refreshData = {
        sectionId: this.section.sectionId,
        parentId: this.parentId, 
        courseId: this.courseId,
        classId: this.classId
      };
      await this.$Courses.Store.updateSectionA(req);
      await this.goToRefreshSectionsTree(refreshData);
      this.fileComponent.setSaving(false);
      this.onClose();
    } catch(err) {
      this.fileComponent.setSaving(false);
      this.onUploadEpubError(err);
    }
  }

  saveFile(fileObject: IResultCreateFileObject) {
    this.createObject({
      type: (fileObject.type === SECTION_TYPES.LESSON_OTHER_FILE.code) ? SECTION_TYPES.LESSON_OTHER_FILE.code : 
      (fileObject.type === SECTION_TYPES.LESSON_PPT_HTML.code) ? SECTION_TYPES.LESSON_PPT_HTML.code :
      (fileObject.type === SECTION_TYPES.LESSON_PDF_IMAGE.code) ? fileObject.type : SECTION_TYPES.LESSON_TEMP_FILE.code,
      name: fileObject.name,
      file: fileObject.file,
      homework: fileObject.homework,
      homeworkPoints: fileObject.homeworkPoints,
      homeworkWeight: fileObject.homeworkWeight,
      parentId: this.parentId,
      courseId: this.params.courseId,
      classId: this.params.classId,
      submissionDates: { 
        dueSchoolDay: this.getSchoolDayIndex(fileObject.dueDate),
        lastSchoolDay: this.getSchoolDayIndex(fileObject.lastDate),
        dueDateAuto: fileObject.dueDateAuto,
        lastDateAuto: fileObject.lastDateAuto
      },
      saveAsPdf: fileObject.saveAsPdf,
      labelSections: fileObject.labelSections,
      component: fileObject.component,
    })
    .then(() => { this.onClose(); })
    .catch((error) => {
      this.onUploadEpubError(error);
    })
    .finally(() => {
      this.fileComponent.setSaving(false);
    });
  }

  onClose() {
    this.$EdModal.closeModal();
  }

  changePdfUrl(data) {
    this.createParams.url = this.pdfUrl;
  }

  created() {
    if(this.params.edition) {
      let dates = this.section.submissionDates || {}; 
      let filename = this.section.assetsInfo[0].fileName.split('.');
      this.createParams.edition = true;
      this.createParams.homework.value = this.section.homework;
      this.createParams.homeworkPoints = this.section.homeworkPoints;
      this.createParams.homeworkWeight = this.section.homeworkWeight;
      this.createParams.hasBeenResolvedByAnyStudent = this.section.hasBeenResolvedByAnyStudent;
      this.createParams.type = this.section.type;
      this.createParams.ext = (this.section.assetsInfo[0].directory) ? 'zip' : filename[filename.length - 1];
      this.createParams.name = this.section.name;
      this.createParams.text = this.section.text;
      this.createParams.title = String(this.$i18n.t('lesson.editFileTitle'));
      this.createParams.file = { name: this.section.name };
      this.createParams.dueDate = this.getSchoolDayDate(dates.dueSchoolDay);
      this.createParams.lastDate = this.getSchoolDayDate(dates.lastSchoolDay);
      this.createParams.submissionDates = this.section.submissionDates;
      this.createParams.hasBeenResolvedByAnyStudent = this.section.hasBeenResolvedByAnyStudent;
      this.createParams.labelSections = this.section.labelSections;
      this.createParams.url = this.pdfUrl;
    } else {
      this.createParams.title = String(this.$i18n.t('courses.objects.createFile'));
    }
    if(this.params.preload) {
      let filename: string = this.params.preload.file.name;
      let file = filename.split('.');
      let ext = file[file.length-1];
      this.createParams.edition = false;
      this.createParams.preload = true;
      this.createParams.name = filename.replace(`.${ext}`, '');
      this.createParams.homework.value = false;
      this.createParams.file = this.params.preload.file;
      this.createParams.ext = ext;
    }
    this.createParams.courseId = this.params.courseId;
    this.createParams.minDate = this.params.minDate;
    this.createParams.hasTagSelector = this.params.contentType === 'TEMPLATE';
    this.loaded = true;
    this.createParams.hasGrading = this.params.hasGrading;
  }

  onUploadEpubError(error) {
    if(error.data && error.data.status === 400 && error.data.errors) {
      this.fileComponent = this.$refs.EdCreateFileObject;
      this.fileComponent.removeFile();
      let errors = error.data.errors[0];
      let message = String(this.$i18n.t(`errors.codes.${errors.status}`));
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courses.errors.errorTitle'),
        body: message,
        type: KEYS.EVENT_TYPES.DANGER
      });
    } else {
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courses.errors.errorTitle'),
        body: this.$i18n.t('courses.errors.errorSavingObject'),
        type: KEYS.EVENT_TYPES.DANGER
      });
    }
  }

  goBack() {
    this.setIsReadyToShow();
    this.rotatePages = false;
  }

  goRotatePages(){
    this.rotatePagesParams = this.section;
    this.setIsReadyToShow();
    this.rotatePages = true;
  }

  onRotatePages(data: any) {
    this.rotateDegreesInfo = data;
    this.setIsReadyToShow();
    this.rotatePages = false;
  }

  setIsReadyToShow(){
    this.isReadyToShow = false;
    setTimeout(() => {
      this.isReadyToShow = true;
    }
    , 500)
  }

  onRemoveRotationData(isRemoved: boolean) {
    if(isRemoved) {
      this.rotateDegreesInfo = [];
    }
  }

}